// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image_bBxFQ {
  background-repeat: no-repeat;
  background-size: contain;
  height: 200px;
  width: 200px;
  background-position: 50% 50%;
}

.block_V54eG {
  opacity: 0.1 !important;
}

.block_V54eG:hover {
  opacity: 1;
}

.propertyGrid_ciDeC {
  --size-padMedium:2px;
  border-radius : 6px;
  padding : 0px 0px 8px 0px;
  background-color : white;
}`, "",{"version":3,"sources":["webpack://./src/plugins/dataViewers/lineStageGanttChart/LinearViewBlock.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,wBAAwB;EACxB,aAAa;EACb,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;AAC1B","sourcesContent":[".image {\n  background-repeat: no-repeat;\n  background-size: contain;\n  height: 200px;\n  width: 200px;\n  background-position: 50% 50%;\n}\n\n.block {\n  opacity: 0.1 !important;\n}\n\n.block:hover {\n  opacity: 1;\n}\n\n.propertyGrid {\n  --size-padMedium:2px;\n  border-radius : 6px;\n  padding : 0px 0px 8px 0px;\n  background-color : white;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"image": `image_bBxFQ`,
	"block": `block_V54eG`,
	"propertyGrid": `propertyGrid_ciDeC`
};
export default ___CSS_LOADER_EXPORT___;
